// extracted by mini-css-extract-plugin
var _1 = "container--oO_o_vWu";
var _2 = "userInfo--VavJsvNA";
var _3 = "userInfoDefinition--fK1iB1II";
var _4 = "userInfoTitle--NtRVP2iH";
var _5 = "userRole--Rg5i8usv userInfoDefinition--fK1iB1II";
export { _1 as "container", _2 as "userInfo", _3 as "userInfoDefinition", _4 as "userInfoTitle", _5 as "userRole" }
